<dx-popup
    #addTemporaryVendorPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="40%"
    title="Add New Temporary Vendor"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form
                        width="100%"
                        height="100%"
                        [labelLocation]="defaulLabelLocation"
                        [colCount]="1"
                        [scrollingEnabled]="true"
                    >
                        <dxi-item [isRequired]="true">
                            <dxo-label text="Vendor Name"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [maxLength]="100" [(value)]="workOrderVendor.vendorName"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Contact First Name"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [maxLength]="50" [(value)]="workOrderVendor.firstName"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Contact Last Name"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [maxLength]="50" [(value)]="workOrderVendor.lastName"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Phone"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    mode="tel"
                                    useMaskedValue="true"
                                    [mask]="phoneMask"
                                    [maxLength]="30"
                                    [maskRules]="phoneMaskRules"
                                    [(value)]="workOrderVendor.phone"
                                >
                                    <dx-validator>
                                        <dxi-validation-rule
                                            type="pattern"
                                            [pattern]="phonePattern"
                                            message="Your phone must have &#34;(555) 555-5555&#34; format!"
                                        ></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Fax"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [maxLength]="30" [(value)]="workOrderVendor.fax"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Email"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box mode="email" [maxLength]="100" [(value)]="workOrderVendor.email">
                                    <dx-validator>
                                        <dxi-validation-rule
                                            type="pattern"
                                            [pattern]="emailPattern"
                                            message="Invalid email address!"
                                        ></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item [isRequired]="true">
                            <dxo-label text="Remit Address"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [maxLength]="100" [(value)]="workOrderVendor.remitAddress"></dx-text-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
